import Linkify from 'react-linkify'
import tw, { styled } from 'twin.macro'
import TailwindConfig from '../../../../tailwind.config'
import { BodyText } from './Texts'

type BodyTextWithLinksProps = {
  children?: string | null
}

const StyledBodyText = styled(BodyText)`
  ${() => tw`whitespace-pre-line`}
  a {
    text-decoration: none;
    color: ${TailwindConfig.theme.extend.colors.accentroAqua.full};
    &:hover {
      text-decoration: underline;
    }
  }
`

export const BodyTextWithLinks = ({ children }: BodyTextWithLinksProps) => {
  return (
    <StyledBodyText>
      <Linkify>{children}</Linkify>
    </StyledBodyText>
  )
}
